import React, { useContext } from 'react';
import { get } from 'lodash';
import { I18nReactContext } from '../../../../contexts/I18nContext';
import { QuestionnaireReportChart } from '../../../Charts/QuestionnaireReportChart/QuestionnaireReportChart';
import './SurveyQuestionsResults.scss';

/**
 * SurveyQuestionsResults Component
 * 
 * Displays survey questions with their corresponding charts and response data.
 * Shows comprehensive analysis for each question in the survey.
 * 
 * @param {object} params - Component parameters
 * @param {Array} params.questionsData - Array of question objects with response data
 * @param {object} params.surveyData - Survey metadata including total responses
 * @returns {JSX.Element} Rendered survey questions results component
 */
export const SurveyQuestionsResults = ({ questionsData, surveyData }) => {
    const { i18n } = useContext(I18nReactContext);

    return (
        <div className="SurveyQuestionsResults">
            <div className="questionsResults">
                <div className="questionsList">
                    {questionsData.map((question, index) => (
                        <div key={get(question, 'id', index)} className="questionResult">
                            <QuestionnaireReportChart
                                surveyData={get(question, 'responses', [])}
                                questionText={get(question, 'questionText', '')}
                                questionNumber={index + 1}
                                allowChartTypeSwitch={true}
                                showMetadata={true}
                                questionType={get(question, 'questionType', '')}
                                totalResponses={get(surveyData, 'totalResponses', 0)}
                                freeTextResponses={get(question, 'freeTextResponses', [])}
                                height={350}
                                labelText={String(i18n.translate('surveyCharts.tooltips.responses'))}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}; 